import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-12 px-4 bg-white" data-id="element-100" data-mp="1o3x39onecu32">
      <div className="max-w-2xl mx-auto text-center" data-id="element-101" data-mp="1o33u6h0ytshr">
        <div className="w-16 h-16 mx-auto mb-3 rounded-full bg-sage-100 border border-sage-300 flex items-center justify-center" data-id="element-102" data-mp="2236cg4d6qnxj">
          <ShieldCheck className="w-9 h-9 text-sage-600" data-id="element-103" data-mp="1x5mvgwp3rx1w" />
        </div>
        <h2 className="font-serif text-2xl md:text-3xl font-bold text-wine tracking-tight" data-id="element-104" data-mp="19e7qsx9ut3nh">
          GARANTÍA DE 7 DÍAS
        </h2>
        <span className="inline-block mt-2 mb-5 bg-sage-500 text-white text-[11px] font-extrabold uppercase tracking-widest px-3 py-1 rounded-full" data-id="element-105" data-mp="14gz7uugvsvl6">
          ✓ Compra sin riesgo
        </span>

        <div className="rounded-2xl bg-sage-50 border border-sage-300 px-5 py-7 sm:px-8" data-id="element-106" data-mp="1ed26vrgfse3w">
          <p className="text-base sm:text-lg text-wine font-bold leading-snug" data-id="element-107" data-mp="qn7vzffogzma">
            Accedé al Kit. Explorá los módulos. Mirá las actividades. Empezá el
            recorrido.
          </p>
          <p className="text-sm sm:text-base text-ink-muted mt-3 leading-snug" data-id="element-108" data-mp="oygo4m1spqdz">
            Si durante los próximos 7 días sentís que no era lo que esperabas:
          </p>
          <p className="font-serif text-6xl sm:text-7xl font-bold text-sage-600 leading-none mt-4" data-id="element-109" data-mp="ypkx954sih0w">
            100%
          </p>
          <p className="font-serif text-lg sm:text-xl font-bold text-wine uppercase tracking-tight mt-2" data-id="element-110" data-mp="12pmsavg0sc77">
            De tu dinero de vuelta
          </p>
          <p className="text-sm text-ink-soft mt-2" data-id="element-111" data-mp="azqr16ez7qpm">Simple y sin complicaciones.</p>
        </div>

        <p className="text-sm text-ink-soft mt-3" data-id="element-112" data-mp="f1by2b4txarw">
          Tenés 7 días para decidir si Desafío Lector es para ustedes.
        </p>
      </div>
    </section>;
}